
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#000000","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M9.5 3.999v-2.5M5 8.499H2.5M6.318 5.317L4.55 3.55M10.934 19.076l-3.4 3.4a3.508 3.508 0 01-4.949 0l-1.061-1.06a3.511 3.511 0 010-4.95l3.4-3.4M15.5 8.5h4.377a3.685 3.685 0 013.623 3.576v2a3.576 3.576 0 01-3.647 3.424H15.5"}})])])
          )
        }
      }
    